import { render, staticRenderFns } from "./WebPartPricePlanDesigner.vue?vue&type=template&id=2e3720e6&scoped=true&"
import script from "./WebPartPricePlanDesigner.vue?vue&type=script&lang=js&"
export * from "./WebPartPricePlanDesigner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3720e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e3720e6')) {
      api.createRecord('2e3720e6', component.options)
    } else {
      api.reload('2e3720e6', component.options)
    }
    module.hot.accept("./WebPartPricePlanDesigner.vue?vue&type=template&id=2e3720e6&scoped=true&", function () {
      api.rerender('2e3720e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/featureOnePage/webParts/WebPartPricePlanDesigner.vue"
export default component.exports